/* eslint-disable max-len */
import { useFormikContext } from 'formik';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSealOfBiliteracyContext } from 'src/contexts/SealOfBiliteracyContext';
import { useAppSelector } from 'src/redux/hooks';
import { selectSealOfBiliteracyStudentFiles } from 'src/redux/slices/sealOfBiliteracySlice';
import { SealOfBiliteracyModel } from 'src/types/SealOfBiliteracyModel';
import SOBAssessmentPanel from './SOBAssessmentPanel';
import SOBStudentPanel from './SOBStudentPanel';
import SOBUploadDocuments from './SOBUploadDocuments';

interface SOBLayoutProps {
  schoolYear?: string;
}

const SOBLayout = ({ schoolYear }: SOBLayoutProps): ReactElement => {
  const params = useParams();
  const dataEntryMode = params.sealOfBiliteracyId === 'new' ? 'new' : 'edit';
  const isEditMode = dataEntryMode === 'edit';
  const { values } = useFormikContext<SealOfBiliteracyModel>();
  const studentFiles = useAppSelector(selectSealOfBiliteracyStudentFiles);
  const { setIsEditMode } = useSealOfBiliteracyContext();

  useEffect(() => {
    setIsEditMode(isEditMode);
  }, [isEditMode, setIsEditMode]);

  const isStudentInfoValid =
    values.studentFirstName && values.studentLastOrSurname;
  const panelsDisabled = !isStudentInfoValid;

  return (
    <>
      <SOBStudentPanel dataEntryMode={dataEntryMode} />
      <br />
      <SOBAssessmentPanel schoolYear={schoolYear} disabled={panelsDisabled} />
      <br />
      <SOBUploadDocuments
        schoolYear={schoolYear}
        studentIdentifier={values.studentIdentifier}
        leaIdentifier={values.leaIdentifier}
        studentFiles={studentFiles}
        disabled={panelsDisabled}
      />
    </>
  );
};

export default SOBLayout;
